import * as clsApi from "./classroomApi";
import * as loginApi from "./loginApi";

export type LoginDetails = {
	deviceid: string;
	username: string;
	token: string;
};

export type LoginResponse = LoginDetails & {
	userflowToken: string;
	userflowUserIdentity: string;
	userflowCompanyIdentity: string;
	masquerade?: boolean; // Omitted if not masquerade, present and true if it is.
};

export type StandardLoginDetails = {
	deviceid: string;
	username: string;
	token: string;
	password: string;
};

export type LoginDelegatedRequest = {
	deviceid: string;
	code: string;
};

export type LoginStandardRequest = {
	deviceid: string;
	username: string;
	password: string;
};

export type LoginFailure = {
	error: string;
};

export type LoginToggle = {
	enabled: string;
};

export interface ServerError {
	error: string;
}

//TODO: this belongs in api.js
export interface ApiError<T> {
	name: string;
	respJson: T;
	error: string;
}

export interface Group {
	active: boolean;
	id: string;
	stableIdV1: string;
	description: string;
	name: string;
	distinguishedName: string;
	sourceType: string;
}

export interface UserInfo {
	firstName: string;
	lastName: string;
	id: string;
	stableIdV1: string;
	username: string;
	sourceType: string;
	email: string;
	groups: Group[];
	groupsOwned: Group[];
}

export interface DeviceInfo {
	user_defined_name: string;
	deviceid: string;
	timezone: string;
	region: string;
	customer_internal_company?: string;
}

export interface AutomaticLoginToken {
	session_token: string;
	userid: string;
	deviceid: string;
}

export interface DeviceStats {
	deviceid: string;
	last_status: boolean;
	last_version: string;
	last_os_version: string;
	last_online_timestamp: string;
	last_uptime: string;
	last_maintenance: boolean;
	last_status_offline_time: number;
	last_status_offline_notified: boolean;
}

export interface LoginMethodError {
	provider: string;
}

export async function loginDelegated(provider: loginApi.LoginProvider, loginRequest: LoginDelegatedRequest): Promise<LoginResponse> {
	const res = await clsApi.Post<LoginDelegatedRequest, LoginResponse>(`auth/${provider.toLowerCase()}`, loginRequest);
	return res;
}

export async function loginStandard(loginRequest: LoginStandardRequest): Promise<LoginResponse> {
	const res = await clsApi.Post<LoginStandardRequest, LoginResponse>(`auth/standard`, loginRequest);
	return res;
}

export async function loginMasquerade(loginRequest: LoginDetails): Promise<LoginResponse> {
	const res = await clsApi.Post<LoginDetails, LoginResponse>(`auth/masquerade`, loginRequest);
	return res;
}

// Note: this endpoint is rarely used, with the purpose to automatically log in the teacher when they are on-network.
// Use verifyAuth to re-verify teacher auth
export async function loginAutomatic(search: string): Promise<LoginDetails> {
	const res = await clsApi.Post<null, LoginDetails>(`auth/automatic${search}`, null);
	return res;
}

export const verifyAuth = async (): Promise<LoginResponse> => {
	const endpoint = `v1/verify-auth`;
	return await clsApi.Put2<undefined, LoginResponse>(endpoint, undefined);
};
